import { useMemo } from "react";
import { sanitizeHtml } from "../utils/sanitizeHtml";

// Shared memoized sanitization: skips sanitizeHtml only for null/undefined (matching the prior
// per-call-site behavior, which still sanitized an empty string), memoizing on [value, options].
// `options` must be a stable reference (a module-level constant) — a freshly-created object
// literal defeats the memoization.
export const useSanitizedHtml = (value, options) =>
  useMemo(() => (value != null ? sanitizeHtml(value, options) : null), [value, options]);
